import { API } from '../api';
import axiosInstance from '../axiosConfig';

export const getAllProfessionals = async (locationId) => {
  const response = await axiosInstance.get(API.PROFESSIONAL.ALL_PROFESSIONALS + locationId);
  return response;
};
export const addProfessional = async (body) => {
  const response = await axiosInstance.post(API.PROFESSIONAL.ADD_PROFESSIONAL, body);
  return response;
};
export const updateProfessional = async (body) => {
  const response = await axiosInstance.patch(API.PROFESSIONAL.UPDATE_PROFESSIONAL, body);
  return response;
};
export const deleteProfessional = async (id) => {
  const response = await axiosInstance.delete(API.PROFESSIONAL.DELETE_PROFESSIONAL + id);
  return response;
};

// Replaces the FULL set of professionals linked to a service.
export const setProfessionalsForService = async (serviceId, professionalIds) => {
  const response = await axiosInstance.post(`${API.PROFESSIONAL.BY_SERVICE}${serviceId}/link`, {
    professionalIds
  });
  return response;
};
export const getProfessionalsForService = async (serviceId) => {
  const response = await axiosInstance.get(`${API.PROFESSIONAL.BY_SERVICE}${serviceId}`);
  return response?.data?.data || [];
};
// `workingDays[].from/to` and `breaks[].startTime/endTime` are ISO datetimes whose UTC
// hour/minute is the time of day — see pages/Professionals/timeOfDay.js.
export const setWorkingHours = async (professionalId, workingDays) => {
  const response = await axiosInstance.post(
    `${API.PROFESSIONAL.BASE}${professionalId}/working-hours`,
    { workingDays }
  );
  return response;
};
export const getWorkingHours = async (professionalId) => {
  const response = await axiosInstance.get(
    `${API.PROFESSIONAL.BASE}${professionalId}/working-hours`
  );
  return response?.data?.data || [];
};

/**
 * Which professionals are linked to each service at a location. The backend
 * links per service only, so this fans out one request per service — fine
 * for a location's handful of services.
 * @param {{id: number}[]} services
 * @returns {Promise<Map<number, Object[]>>} serviceId -> linked professionals
 */
export const getProfessionalLinksByService = async (services) => {
  const entries = await Promise.all(
    (services || []).map(async (service) => [
      service.id,
      await getProfessionalsForService(service.id).catch(() => [])
    ])
  );
  return new Map(entries);
};

/**
 * Incremental, professional-centric linking: adds `newServiceIds` and removes
 * `removeServiceIds` for one professional in a single transaction. Omit
 * either array to only add or only remove.
 * @param {number} professionalId
 * @param {{ locationId: number, newServiceIds?: number[], removeServiceIds?: number[] }} body
 */
export const linkServicesToProfessional = async (professionalId, body) => {
  const response = await axiosInstance.post(
    `${API.PROFESSIONAL.BASE}${professionalId}/link-services`,
    body
  );
  return response;
};
